import { react2angular } from 'react2angular';
import CreateAlarmRule from './CreateAlarmRule';

angular
  .module('analysis.module')
  .component('createAlarmRule', react2angular(CreateAlarmRule, [
    'hasAccessAlarms',
    'startDate',
    'endDate',
    'mode',
    'value',
    'units',
    'defaultWindowHours',
    'onStartDateChange',
    'onEndDateChange',
    'onModeChange',
    'onValueChange',
    'onReset',
    'onInitializeRange',
    'occurrences',
    'intervalValue',
    'intervalUnit',
    'intervalUnits',
    'onOccurrencesChange',
    'onIntervalValueChange',
    'onIntervalUnitChange',
    'isIntervalLongerThanDataWindow',
    'isCreateRuleDisabled',
    'isRunReportDisabled',
    'createRuleDisabledReason',
    'runReportDisabledReason',
    'onCreateRule',
    'onRunReport',
  ]));
